import {
    Modal,
    Table,
} from 'antd';
import {TableProps} from 'antd/es/table';
import React from 'react';

import {ReactComponent as CloseIcon} from 'shared/assets/close.svg';
import {TModalComponentInterface} from 'store/slices/modals-slice';

import s from './info-table-modal.module.less';

export interface IInfoTableModalProps<T> extends TModalComponentInterface {
    columns?: TableProps<T>['columns'];
    dataSource?: TableProps<T>['dataSource'];
    modalTitle?: string;
    isLoading?: boolean;
}

export const InfoTableModal = <T extends object>(props: IInfoTableModalProps<T>) => {
    const {
        onClose,
        columns,
        dataSource,
        modalTitle,
        isLoading,
    } = props;

    return (
        <Modal
            title={modalTitle}
            className={s['info-table-modal']}
            onCancel={onClose}
            visible
            maskClosable={false}
            closeIcon={<CloseIcon className="modal-close-icon with-title" />}
            footer={null}
        >
            <Table
                columns={columns}
                dataSource={dataSource}
                loading={isLoading}
                pagination={false}
            />
        </Modal>
    );
};
